import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import ProgressBar from "../../components/ProgressBarWithBackArrow/ProgressBarWithBackArrow";
import "../SignupPages/SignupCommon.css";

const NadPlusPage12: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const navigate = useNavigate();

  useEffect(() => {
    const step11Completed = localStorage.getItem("completed-step-11");
    if (step11Completed) {
      navigate("/nadplus/getting-started/step-12", { replace: true });
    } else {
      navigate("/nadplus/getting-started/step-11", { replace: true });
    }
  }, []);

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);
  
    const storedState = localStorage.getItem("state");
    let parsedState = "";
    if (storedState) {
      const parsed = JSON.parse(storedState);
      parsedState = parsed.value; // expecting "NC", "SC", etc.
    }
  
    // Disqualification logic
    if ((parsedState === "NC" || parsedState === "SC") && option === "Nasal spray") {
      localStorage.setItem(
        "What_is_your_preference_for_NAD+_intake",
        JSON.stringify({
          key: "What_is_your_preference_for_NAD+_intake",
          value: option,
        })
      );
      localStorage.setItem("completed-step-12", "true");
  
      navigate("/nadplus/disqualified-by-state");
      return;
    }
  
    // Normal flow
    localStorage.setItem(
      "What_is_your_preference_for_NAD+_intake",
      JSON.stringify({
        key: "What_is_your_preference_for_NAD+_intake",
        value: option,
      })
    );
    localStorage.setItem("completed-step-12", "true");
  
    setTimeout(() => {
      navigate("/nadplus/getting-started/step-13");
    }, 1500);
  };
  

  useEffect(() => {
    const saved = localStorage.getItem("What_is_your_preference_for_NAD+_intake");
    if (saved) {
      const parsed = JSON.parse(saved);
      setSelectedOption(parsed.value);
    }
  }, []);

  const handleBack = () => {
    navigate("/nadplus/getting-started/step-11");
  };

  const options = ["Injection", "Nasal spray"];

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={92} onBack={handleBack} />
        <div className="signup-content">
          <p className="signup-intro">What is your preference for NAD+ intake?</p>
          <div className="options options-box">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOption === option ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default NadPlusPage12;